import { db } from "../../services/firebase/Config";

import { SET_RECETA, GUARDAR_RECETA } from "./recetaTypes";

import { httpRequest, httpSuccess, httpFailure } from "../sesion/sesionActions";

export const setReceta = (receta) => {
  return {
    type: SET_RECETA,
    payload: receta,
  };
};

export const guardarReceta = (receta) => {
  return function (dispatch) {
    let recetasRef = undefined;
    const empresaId = receta.empresaId;
    if (!empresaId) {
        console.error("empresaId missing in guardarReceta");
    }
    const recetasCollection = db.collection("empresas").doc(empresaId).collection("pacientes").doc(receta.pacienteId).collection("recetas");

    if (receta.id) {
      recetasRef = recetasCollection.doc(receta.id);
    } else {
      recetasRef = recetasCollection.doc();
    }
    dispatch(httpRequest());
    receta.id = recetasRef.id;
    recetasRef
      .set(receta)
      .then(() => {
        dispatch(httpSuccess());
        //dispatch(setReceta(receta));
      })
      .catch((error) => {
        dispatch(httpFailure(error));
      });
  };
};
